import { useCompanyContext } from "@app/companyTab/CompanyTab";
import { DocumentsBlock } from "."

interface Props {
  prefix: string;
}
export const DocumentsWrapper = ({prefix}: Props) => {
  const { formConfig, inn } = useCompanyContext();
  const documentsConfig = formConfig?.tabs?.documents.components[prefix];

  return (
    <DocumentsBlock prefix={prefix} config={documentsConfig} userInfo={{ company: { inn } }} />
  )
}
